import { useEffect, useRef, useState } from 'react';
import { Card, CardHeader, Divider, IconButton, Typography, Paper } from "@mui/material";
import Loader from "../shared/loaders/dashboard-stats-loader.json"
import AnimateLoader from "../shared/loaders/animate-loader.component";
import { InformationDarkIcon } from '../../icon';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from "recharts";

interface Props {
    avatar: any;
    statistics: any[];
    IsMobileDevice?: boolean;
    IsTeamsApp?: boolean;
    ShowLoader?: boolean;
}

const StatisticsChartComponent = (props: Props) => {
    const ref = useRef<any>()
    let Days = parseInt(sessionStorage.getItem("statsPreference") || "7");
    const [title, setTitle] = useState<string>(`Statistics of Last ${Days} days`)
    const [stats, setStats] = useState<any>({
        labels: [],
        datasets: [
            {
                label: "Messages Sent",
                backgroundColor: "rgba(75,192,192,1)",
                yAxisID: "bar-stacked",
                data: [],
            },
            {
                label: "Messages Received",
                backgroundColor: "#396AFF",
                yAxisID: "bar-stacked",
                data: [],
            },
        ],
    });
    const [days, setDays] = useState<any>([7, 14, 30])
    const [value, setValue] = useState<number>(Days)
    const [yAxisValue, setYAxisValue] = useState<number>(0)
    const [statistics, setStatisttics] = useState<any>(props.statistics)

    useEffect(() => {
        ref.current.parentElement.className = `${ref.current.parentElement.className} my-auto`;
    }, [])

    useEffect(() => {
        if (statistics !== props.statistics) {
            FetchDays(parseInt(sessionStorage.getItem("statsPreference") || "7"), props.statistics)
        }
    }, [props.statistics])

    const FetchDays = (value: any, Stat: any) => {
        setValue(value)
        sessionStorage.setItem("statsPreference", value);
        let length = value > Stat?.labels?.length ? value : Stat?.labels.length;
        let Labels = Stat.labels?.slice(length - value, length)
        let messageSent = Stat.datasets[0].data.slice(length - value, length)
        let messageReceived = Stat.datasets[1].data.slice(length - value, length)
        let obj = {
            labels: Labels,
            datasets: [{
                "label": "Messages Sent",
                "backgroundColor": "rgba(75,192,192,1)",
                "yAxisID": "bar-stacked",
                "data": messageSent
            }, {
                "label": "Messages Received",
                "backgroundColor": "#396AFF",
                "yAxisID": "bar-stacked",
                "data": messageReceived
            }]
        }
        var sum = messageSent.map((num: number, index: number) => num + messageReceived[index]);
        let maxValue = Math.max(...sum);
        let yMax = Math.ceil(maxValue / 20) * 20;
        setStats(obj)
        setTitle(`Statistics for last ${value} days`)
        setYAxisValue(yMax)
    }

    const onDisplayData = (value: any) => {
        FetchDays(value, props.statistics);
    }



    return (
        <div>
            <Card className={`${props.IsMobileDevice ? 'stat-overflow dashboard-mobile-stat-border' : 'pb-2 dashboard-statistic-border p-0'} box-shadow-none`}>
                <CardHeader
                    className="py-1 d-flex"
                    classes={{ avatar: `${props.IsMobileDevice && 'mr-1'}` }}
                    avatar={
                        <div className={`bg-dashboard-statistic d-flex justify-center align-center br-1 ${props.IsMobileDevice ? 'w-3 h-3 mr-0 statictics-avatar' : 'w-5 h-5'}`}>{props.avatar}</div>
                    }
                    action={
                        <div ref={ref} className="d-flex">

                            <Paper className="box-shadow-none bg-color-vigenary my-auto d-flex mr-1">

                                <span className={`my-auto ${props.IsMobileDevice ? 'py-1' : 'py-2 px-1 '}`}>
                                    {days.map((day, index) => <button key={index} className={`stat-button-mobile-view ${value == day ? " stat-button-active" : ""} h5-regular c-pointer br-2`} onClick={() => onDisplayData(day)}>{`${day} days`}</button>)}</span>
                            </Paper>

                            {/* <Tooltip title={title} placement="bottom-end" enterTouchDelay={props.IsMobileDevice ? 200 : 0}>
                                <IconButton size="small" className={`${props.IsMobileDevice ? 'p-1' : 'p-2'}`}>
                                    {props.IsMobileDevice ? "" : <InformationDarkIcon />}
                                </IconButton>
                            </Tooltip> */}
                        </div>
                    }
                    title={
                        <Typography className={`${props.IsMobileDevice ? 'stat-title-mobile-view h4' : 'stat-title dashboard-statistics-heading'}  t-align-left`}>
                            Statistics
                        </Typography>
                    }
                />
                <Divider />
                {
                    !!props.ShowLoader ?
                        <AnimateLoader LoaderAnimation={Loader} className={"w-fill"} />
                        :
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart
                                width={500}
                                height={300}
                                data={stats.labels.map((label: string, index: number) => ({
                                    date: label,
                                    sentMessages: stats.datasets[0].data[index],
                                    receivedMessages: stats.datasets[1].data[index],
                                }))}
                                margin={{ top: 20, right: 40, left: 0, bottom: 0 }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                    dataKey="date"
                                    type="category"
                                    // tick={{ fill: "#e5e7eb" }}
                                    tickLine={{ stroke: "#e5e7eb" }}
                                />
                                <YAxis
                                    // ticks={[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50]}
                                    // tick={{ fill: "#e5e7eb" }}
                                    tickLine={{ stroke: "#e5e7eb" }}
                                />
                                <Tooltip
                                    contentStyle={{
                                        backgroundColor: "#18212f",
                                        color: "#e5e7eb",
                                        fontWeight: "bold"
                                    }}
                                />
                                <Legend
                                    align="right"
                                    wrapperStyle={{ fontWeight: "bold", fontSize: "11px" }}
                                />
                                <Bar dataKey="sentMessages" stackId="a" fill="rgba(75,192,192,1)" name="Messages Sent" barSize={55} />
                                <Bar dataKey="receivedMessages" stackId="a" fill="#396AFF" name='Messages Received' barSize={55} />
                            </BarChart>
                        </ResponsiveContainer>
                }
            </Card>
        </div >
    )
}
export default StatisticsChartComponent;
